import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const stopsMessages = defineMessages({
  min: {
    id: 'routes.new.form.stops.min',
    defaultMessage: 'Your route needs at least 2 stops in order to be edited'
  }
})

const stopMessages = defineMessages({
  required: {
    id: 'routes.new.form.stop.required',
    defaultMessage: 'You should select a place for this stop'
  }
})

const distanceMessages = defineMessages({
  required: {
    id: 'routes.new.form.distance.required',
    defaultMessage: 'You need to calculate the distance of your route before continuing'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    stops: yup
      .array()
      .min(2, intl.formatMessage(stopsMessages.min))
      .of(
        yup.object().shape({
          id: yup.string().required(intl.formatMessage(stopMessages.required))
        })
      ),
    distance: yup.number().required(intl.formatMessage(distanceMessages.required))
  })
}
